'use client';
import Link from '@/components/_rebrand/Link';
import { ButtonWithLinkOrAction } from '@/components/buttons/Button.types';
import { useModalButtonActions } from '@/hooks/useModalButtonActions';
import cx from 'classnames';
import { FC } from 'react';

export type PlanCardProps = {
  image: React.ReactNode;
  planTitle: string;
  planDescription: string;
  planLinks: ButtonWithLinkOrAction[];
  planSmallLink: {
    title: string;
    href: string;
  };
}

const PlanCard: FC<PlanCardProps> = ({ planTitle, planDescription, planLinks, planSmallLink, image }) => {
  const { modalActionHandler } = useModalButtonActions();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-gutter-mobile md:gap-x-gutter-desktop">
      <div className="lg:col-span-10 lg:col-start-2">
        <div className='bg-blue-200 rounded-10 overflow-hidden'>
          <div className='grid grid-cols-10 gap-x-gutter-mobile md:gap-x-gutter-desktop'>
            <div className='col-span-10 lg:col-span-7 p-3 md:py-8 md:px-6'>
              <div className='flex flex-col gap-2 md:gap-3'>
                <p className='text-25/30 md:text-43/52 font-500 tracking-tight text-blue-900'>{planTitle}</p>
                <p className='text-17/24 md:text-20/28 text-blue-900'>{planDescription}</p>
                <ul className="flex flex-col gap-2 md:flex-row items-start md:items-center">
                  {planLinks.map((link, index) => (
                    <li key={`plan-link-${link.title?.replace(/\s+/g, '-') ?? index}`}>
                      {link.href.length ? (
                        <Link
                          className={cx('block', {
                            'button button-size-medium button-primary-violet': link.type === 'primary',
                            'button button-size-medium button-secondary-violet': link.type === 'secondary',
                          })}
                          href={link.href}
                        >
                          {link.title}
                        </Link>
                      ) : (
                        <button
                          className={cx('block', {
                            'button button-size-medium button-primary-violet': link.type === 'primary',
                            'button button-size-medium button-secondary-violet': link.type === 'secondary',
                          })}
                          onClick={() => modalActionHandler(link.action)}
                        >
                          {link.title}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
                <div className='flex'>
                  <Link href={planSmallLink.href} className='text-16/22 font-500'>{planSmallLink.title} <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline"><path d="M3.75 9H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path><path d="M9 3.75L14.25 9L9 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg></Link>
                </div>
              </div>
            </div>
            <div className='col-span-10 lg:col-span-3 relative'>{image}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
